import { defineMessages } from 'react-intl';

type MessageKeys = 'moreBtnLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		moreBtnLabel: {
			id: 'ai-mate.rovo-navigation.side-navigation.more-btn',
			defaultMessage: 'More',
			description: 'Label for the side nav more button',
		},
	});

export default message;
